import { isPlatformBrowser } from '@angular/common';
import { Component, inject, PLATFORM_ID } from '@angular/core';
import { AuthService } from '@spartacus/core';
import { ProductListItemComponent, ProductListItemContextSource } from '@spartacus/storefront';
import { Subject, takeUntil } from 'rxjs';
import { ProductListService } from 'src/app/services/feature/product-list.service';

@Component({
  selector: 'app-pdp-tab-list-item',
  templateUrl: './pdp-tab-list-item.component.html',
  styleUrls: ['./pdp-tab-list-item.component.scss'],
  standalone: false
})
export class PdpTabListItemComponent extends ProductListItemComponent {

  isLoggedIn: boolean = false;
  distributerType: string;
  platformId = inject(PLATFORM_ID);
  private destroy$ = new Subject<void>();
  constructor(public authService: AuthService, public compareService: ProductListService, productListItemContextSource: ProductListItemContextSource) {
    super(productListItemContextSource)
    this.authService
      .isUserLoggedIn().pipe(takeUntil(this.destroy$))
      .subscribe((isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;
      })
    if (isPlatformBrowser(this.platformId)) {
      this.distributerType = document.cookie.split(";")[1]?.split("=")[1]?.split("_")[2];
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
